import { FC } from 'react';

import { Flex, Image, Space, Typography } from 'antd'
import { ActionButton, ActionButtonProps } from '@hdi-seguros/web-components.action-button';

import { ErrorIcon } from '../../../assets';

interface ErrorProps {
    title:      string;
    subtitle?:  string;
    message?:   string | any;
    actions?:   Array<ActionButtonProps>;
}

export const ErrorResults: FC<ErrorProps> = ({ title, subtitle, message = '', actions = [] }) => {
    return (
        <Space
            style={{ display: 'flex', flexDirection: 'column', rowGap: 10, justifyContent: 'center', alignItems: 'center', width: '100%', height: '50vh' }}
        >
            <Image src={ ErrorIcon } width={63} height={63} preview={ false } />

            <Typography.Title level={3}>
                {title}
            </Typography.Title>

            {subtitle && (
                <Typography.Text
                    style={{
                        fontSize: 16,
                        textAlign: 'center',
                    }}
                >
                    {subtitle}
                </Typography.Text>
            )}

            {message && (
                <Typography.Text type="secondary">
                    {message}
                </Typography.Text>
            )}

            <Typography.Text type='secondary' >
                { message }
            </Typography.Text>

            <Flex  align='center' justify='center' gap={10}>
                {
                    actions.map((props, i) => <ActionButton { ...props } key={i} />)
                }
            </Flex>
        </Space>
    )
}
